var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108.118,
    height: 56.529,
    viewBox: "0 0 108.118 56.529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6144",
    "data-name": "Group 6144",
    transform: "translate(-153.631 -119.645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5797",
    "data-name": "Group 5797",
    transform: "translate(153.631 119.645)",
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5796",
    "data-name": "Group 5796",
    transform: "translate(0 6.935)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6890",
    "data-name": "Path 6890",
    d: "M921.521,978.729l-38.1,35.443L863.8,995.593c-3.672,3.6-9.344,9.145-15.05,14.714-3.9,3.806-7.056,6.881-9.615,9.37l-17.819-.021c4.942-4.678,24.841-24.119,38.246-37.258l4.1-4.017,19.83,18.782L912.6,970.083Z",
    transform: "translate(-821.315 -970.083)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6891",
    "data-name": "Path 6891",
    d: "M2279.185,855.963l17.958,18.9,3.591-21.567Z",
    transform: "translate(-2192.615 -853.292)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6139",
    "data-name": "Group 6139",
    transform: "translate(193.422 119.645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7103",
    "data-name": "Path 7103",
    d: "M1560.559,1157.785s-.908-.228-1.168-.283c-.3-.064-.582-.293-.671-.185-.165.2.53.552.8,1.17.135.3.406.469.948.246A.566.566,0,0,0,1560.559,1157.785Z",
    transform: "translate(-1541.451 -1134.286)",
    fill: "#e2915a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5886",
    "data-name": "Group 5886",
    transform: "translate(16.26 0.291)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "man",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7050",
    "data-name": "Path 7050",
    d: "M1765.823,876.318l-2.268,4.3-1.163-.423.378,1.148L1760.5,888.2S1759.238,879.493,1765.823,876.318Z",
    transform: "translate(-1748.907 -867.822)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7051",
    "data-name": "Path 7051",
    d: "M1741.644,950.058a89.337,89.337,0,0,0-2.75,18.068,11.542,11.542,0,0,0,5.348.151C1747.526,967.7,1741.644,950.058,1741.644,950.058Z",
    transform: "translate(-1728.511 -937.758)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7052",
    "data-name": "Path 7052",
    d: "M1538.778,1167.174c.673-.013,1.621.071,1.934-.272a.947.947,0,0,1,.774-.331l-.085-.444-.1-.53s-.038-.048-.176-.047a2.616,2.616,0,0,1-.72-.062c-.567-.2-2.822,1.149-2.746,1.524C1537.685,1167.152,1538.492,1167.179,1538.778,1167.174Z",
    transform: "translate(-1537.655 -1142.053)",
    fill: "#e2915a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7053",
    "data-name": "Path 7053",
    d: "M1606.1,946.544s-3.81,7.869-4.989,8.713a50.164,50.164,0,0,1-5.382,2.671,1.074,1.074,0,0,0-.008.645.8.8,0,0,0,.316.512s5.876-.525,7.242-1.375a35.175,35.175,0,0,0,4.378-4.24Z",
    transform: "translate(-1592.681 -934.425)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5884",
    "data-name": "Group 5884",
    transform: "translate(11.48 25.673)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7054",
    "data-name": "Path 7054",
    d: "M2013.366,1717.541h2.254a1.366,1.366,0,0,0,.617-1.033c.11-.726.924-1.122,1.1-1.717s-.726-1.43-.726-1.43l-.151-.194-.157-.2-1.5.352s-.037.356-.06.81a10.363,10.363,0,0,0-.007,1.038c.044.792-.222,1.646-.926,1.8C2013.295,1717.079,2013.318,1717.388,2013.366,1717.541Z",
    transform: "translate(-2000.281 -1686.977)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7055",
    "data-name": "Path 7055",
    d: "M1760.168,1753.194h5.156c.248-.3.157-1.42.119-1.784-.008-.073-.013-.116-.013-.116s-1.761-1.408-2-.33c-.007.034-.016.067-.026.1-.3,1.009-1.672,1.467-2.461,1.595A.893.893,0,0,0,1760.168,1753.194Z",
    transform: "translate(-1760.168 -1722.63)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7056",
    "data-name": "Path 7056",
    d: "M1779.211,1235.311s.268,3.336.582,7.345c.427,5.447.94,12.138.991,13.405.088,2.2.44,5.722.44,5.722a2.768,2.768,0,0,0,2.509.484,57.565,57.565,0,0,0,1.917-10.343c.007-.087.013-.175.02-.263.4-5.413,1.012-16.812,1.012-16.812Z",
    transform: "translate(-1778.228 -1233.529)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7057",
    "data-name": "Path 7057",
    d: "M1779.211,1235.311s.268,3.336.582,7.345l5.857,9.267c.007-.087.013-.175.02-.263.4-5.413,1.012-16.812,1.012-16.812Z",
    transform: "translate(-1778.228 -1233.529)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7058",
    "data-name": "Path 7058",
    d: "M1802.876,1211.438s4.819,12.081,7.988,17.758,4.159,7.262,4.159,7.262,1.816-.726,1.981-1.221c0,0-1.212-10.96-3.334-13.632-1.2-1.51-2.608-6.04-2.674-7.625s-.429-4.72-.429-4.72Z",
    transform: "translate(-1800.673 -1209.259)",
    fill: "#f99746"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7059",
    "data-name": "Path 7059",
    d: "M1826.128,817.818c1.883.594,5.142-1.01,5.142-1.01a4.9,4.9,0,0,1-1.646-4.013l-1.456,1.173-.989.8a11.879,11.879,0,0,0,.112,1.293c.02.15.043.312.07.486a.349.349,0,0,1-.158.351A4.454,4.454,0,0,0,1826.128,817.818Z",
    transform: "translate(-1811.245 -807.577)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7060",
    "data-name": "Path 7060",
    d: "M1775.093,895.556a.3.3,0,0,0,.2.075,30.572,30.572,0,0,0,4.514.2,13,13,0,0,0,4.171-1.2c.185-.083.613-.311.6-.519-.006-.227-.029-.557-.057-.972a51.906,51.906,0,0,1-.1-6.789c.03-.533.046-1.062.048-1.583.014-3.881-.755-7.3-2.3-8.45a12.809,12.809,0,0,1-1.825.843,1.534,1.534,0,0,1-1.487-.065,4.626,4.626,0,0,0-1.054.711,7.461,7.461,0,0,0-1.678,3.372,28.882,28.882,0,0,0-.725,5.589C1775.349,887.863,1775.046,895.518,1775.093,895.556Z",
    transform: "translate(-1762.838 -867.822)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7061",
    "data-name": "Path 7061",
    d: "M1815.174,882.731l-2.073-6.413s-4.977,1.877-5.207,8.9a81.584,81.584,0,0,0,.22,13.6s3.878,1.511,8.631-1.47Z",
    transform: "translate(-1793.773 -867.822)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7062",
    "data-name": "Path 7062",
    d: "M1846.5,835.817a11.81,11.81,0,0,0,.112,1.293c1.1-.188,2.339-1.959,2.339-1.959a3.49,3.49,0,0,0-1.462-.131Z",
    transform: "translate(-1830.567 -828.628)",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7063",
    "data-name": "Path 7063",
    d: "M1818.526,746.86s3.392.564,3.71-1.554.97-3.471-1.182-3.921-2.7.3-2.974.976S1817.651,746.658,1818.526,746.86Z",
    transform: "translate(-1803.406 -739.721)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5885",
    "data-name": "Group 5885",
    transform: "translate(20.761 27.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7064",
    "data-name": "Path 7064",
    d: "M1949.282,1265.283l-6.925.987a1.66,1.66,0,0,1-1.873-1.405l-.427-3a1.66,1.66,0,0,1,1.405-1.872l6.926-.987a1.66,1.66,0,0,1,1.872,1.405l.428,3A1.66,1.66,0,0,1,1949.282,1265.283Z",
    transform: "translate(-1940.04 -1258.088)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7065",
    "data-name": "Path 7065",
    d: "M1957.746,1245.187l.433,3.036a1.665,1.665,0,0,0,.978,1.286,1.636,1.636,0,0,0,.54.136h0a1.63,1.63,0,0,0,.361-.011l6.913-.986a1.666,1.666,0,0,0,1.41-1.879l-.432-3.036a1.667,1.667,0,0,0-1.88-1.41l-2.38.339-.092-.648a.55.55,0,0,0-.62-.465l-.261.037-1.448.206-.36.052a.549.549,0,0,0-.465.62l.092.648-1.379.2c-.055.008-.108.018-.16.031h0a1.669,1.669,0,0,0-1.147,1h0A1.648,1.648,0,0,0,1957.746,1245.187Zm5.6-2.477-2.474.353-.092-.648a.2.2,0,0,1,.174-.231l.621-.089,1.14-.162.307-.044a.21.21,0,0,1,.061,0,.205.205,0,0,1,.17.173Z",
    transform: "translate(-1956.817 -1241.544)",
    fill: "#2b478b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7066",
    "data-name": "Path 7066",
    d: "M2017.1,1199.1a2.407,2.407,0,0,1,.378.678c.1,1.312-.5,1.494,1.051,2.222,0,0,.663.253.674-.262s-.46-.523-.374-1.243c.1-.831.089-.839-.456-1.272l-.361-.6Z",
    transform: "translate(-1992.361 -1173.498)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7067",
    "data-name": "Path 7067",
    d: "M1881.82,893.791a5.32,5.32,0,0,1-1.219.068s-1.736-5.362-1.96-5.852-5.156-6.288-5.156-6.288l2-5.4a7.965,7.965,0,0,1,2.414,2.828,74.929,74.929,0,0,1,3.517,7.595c.9,2.069,1.206,6.709,1.206,6.709A2.238,2.238,0,0,1,1881.82,893.791Z",
    transform: "translate(-1856.158 -867.822)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7068",
    "data-name": "Path 7068",
    d: "M1806.025,717.026s-.348-.058-.292-.538.055-1.106-.335-.989-.409.429-.569.247-.163-.95-1.323-1-1.631.35-2.171.113-.568-1.054-.568-1.054a.928.928,0,0,0,.385.384s-.9-1.231.142-2.075,2.1-.292,2.707-.255c1.329.08,2.187.16,2.621,1.033A4.793,4.793,0,0,1,1806.025,717.026Z",
    transform: "translate(-1787.193 -711.645)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7069",
    "data-name": "Path 7069",
    d: "M2018.165,1218.981s-.35.365-.372.517c-.071.488-.234.7-.152.751.169.11.394-.251.5-.575A1.482,1.482,0,0,0,2018.165,1218.981Z",
    transform: "translate(-1992.854 -1192.806)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7070",
    "data-name": "Path 7070",
    d: "M1812.579,876.318l-2.268,4.3-1.163-.423.378,1.148-2.274,6.849S1805.994,879.493,1812.579,876.318Z",
    transform: "translate(-1793.251 -867.822)",
    fill: "#233862"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7071",
    "data-name": "Path 7071",
    d: "M1826.128,825.932a.563.563,0,0,0,.463.359.839.839,0,0,0,.585-.312A2.624,2.624,0,0,0,1826.128,825.932Z",
    transform: "translate(-1811.245 -819.995)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5890",
    "data-name": "Group 5890",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5887",
    "data-name": "Group 5887",
    transform: "translate(9.793 30.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7072",
    "data-name": "Path 7072",
    d: "M1432.691,1311.062l6.887-1.6a1.678,1.678,0,0,0,1.252-2.007l-.691-2.985a1.678,1.678,0,0,0-2.007-1.252l-6.887,1.6a1.678,1.678,0,0,0-1.252,2.007l.692,2.985A1.678,1.678,0,0,0,1432.691,1311.062Z",
    transform: "translate(-1429.04 -1302.671)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7073",
    "data-name": "Path 7073",
    d: "M1422.124,1294.577h0a1.686,1.686,0,0,0-1.447-.526h0c-.054.007-.108.016-.162.029l-1.371.318-.149-.644a.555.555,0,0,0-.665-.415l-.358.083-1.44.334-.259.06a.555.555,0,0,0-.415.665l.149.644-2.367.548a1.684,1.684,0,0,0-1.257,2.015l.7,3.019a1.683,1.683,0,0,0,2.014,1.257l6.875-1.593a1.639,1.639,0,0,0,.344-.121h0a1.645,1.645,0,0,0,.459-.325,1.682,1.682,0,0,0,.453-1.568l-.7-3.019A1.665,1.665,0,0,0,1422.124,1294.577Zm-5.93-.175a.207.207,0,0,1,.1-.225.211.211,0,0,1,.058-.023l.306-.071,1.133-.262.618-.143a.207.207,0,0,1,.248.155l.149.644-2.46.57Z",
    transform: "translate(-1412.338 -1293.325)",
    fill: "#ed7d2b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7074",
    "data-name": "Path 7074",
    d: "M1481.8,1239.691a3.043,3.043,0,0,0-.137.973c.484,1.593,1.32,2.635-.928,2.366,0,0,.093-.093-.337-.9-.5-.935-.488-.949-.043-1.709l.154-.869Z",
    transform: "translate(-1466.736 -1212.318)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7075",
    "data-name": "Path 7075",
    d: "M1523.514,1164.74a2.926,2.926,0,0,1-1.808-.578,1.669,1.669,0,0,0-.683-.516l.1-.444.125-.531s.041-.047.18-.04c0,0,.532.12.73-.032a.751.751,0,0,1,.782.088c.283.188.665.158.656.25,0,0-.561.276-.509.322.514.456,1.868.637,1.78.994A2.967,2.967,0,0,1,1523.514,1164.74Z",
    transform: "translate(-1505.622 -1139.264)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7076",
    "data-name": "Path 7076",
    d: "M1314.746,830.211l0,.369s.1,1.154-1.321,1.323-2.587.147-2.549-.744a18.766,18.766,0,0,0,.367-2.331,4.022,4.022,0,0,0-.05-.691l2.754-.055.811.133Z",
    transform: "translate(-1306.315 -822.08)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7077",
    "data-name": "Path 7077",
    d: "M1320.588,828.215l-.01,2a2.329,2.329,0,0,1-.993.219,3.075,3.075,0,0,1-2.511-1.6,4.023,4.023,0,0,0-.051-.691l2.754-.055Z",
    transform: "translate(-1312.148 -822.08)",
    fill: "#e2915a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7078",
    "data-name": "Path 7078",
    d: "M1304.663,740.943c.32,1.72,2.539,1.663,3.5,1.555.27-.03.44-.064.44-.064.3-.081.474-.561.553-1.188a9.775,9.775,0,0,0-.251-3.533c-.316-.7-.911-1.461-3.146-.913S1304.253,738.739,1304.663,740.943Z",
    transform: "translate(-1299.999 -735.329)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7079",
    "data-name": "Path 7079",
    d: "M1277.741,1772.026h3.144a7.6,7.6,0,0,0-.251-1.129,3.216,3.216,0,0,0-.178-.453c-.306-.611-2.249-.222-2.249-.222a1.5,1.5,0,0,0-.321.745A6.266,6.266,0,0,0,1277.741,1772.026Z",
    transform: "translate(-1274.892 -1715.497)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7080",
    "data-name": "Path 7080",
    d: "M1461.883,1747.508a1.7,1.7,0,0,0,.218.992h6.219a1.072,1.072,0,0,0-.941-.667,4.722,4.722,0,0,1-2.517-1.165,1.873,1.873,0,0,1-.487-.883c-.293-1.3-2.42.4-2.42.4A10.557,10.557,0,0,0,1461.883,1747.508Z",
    transform: "translate(-1449.532 -1691.971)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7081",
    "data-name": "Path 7081",
    d: "M1324.256,1223.619a9.808,9.808,0,0,1,.156,1.149c.2,3.857,3.246,12.675,3.792,12.88.844.319,2.173-.359,2.868-.58a.6.6,0,0,0,.418-.677c-1.51-6.941-2.065-16.935-2.267-22.852a26.843,26.843,0,0,0-.614-5.04s-7.436-1.984-7.48.526C1321.091,1211.246,1323.593,1219.956,1324.256,1223.619Z",
    transform: "translate(-1316.042 -1182.165)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7082",
    "data-name": "Path 7082",
    d: "M1324.256,1223.619l4.967-10.08a26.843,26.843,0,0,0-.614-5.04s-7.436-1.984-7.48.526C1321.091,1211.246,1323.593,1219.956,1324.256,1223.619Z",
    transform: "translate(-1316.042 -1182.165)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7083",
    "data-name": "Path 7083",
    d: "M1260.469,1215.884l-3.931,28.489a7.7,7.7,0,0,1-3.069.083s-1.151-15.152-1.055-18.815-.826-9.8.211-10.479S1260.469,1215.884,1260.469,1215.884Z",
    transform: "translate(-1250.601 -1189.015)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7084",
    "data-name": "Path 7084",
    d: "M1291.9,714.407c-.614.193-1.912,0-2.455.435s-.026,1.163-.646,1.422h0a.306.306,0,0,1-.356-.089c-.172-.214-.409-.428-.627-.34-.178.073-.187.3-.109.527a.622.622,0,0,1-.067.563.307.307,0,0,0-.067.227c.052.284.192.653.244.842l.014.2a10.2,10.2,0,0,1-1.477-2.072c-.3-.65-.294-3.077,1.175-3.787a.049.049,0,0,1-.014-.016c-.032-.057-.12-.044-.12-.044a.663.663,0,0,1,.322-.021s0-.012.021-.026a.52.52,0,0,1,.2-.294.58.58,0,0,0-.094.232,3.267,3.267,0,0,1,2.515-.244,7.836,7.836,0,0,0,1.617.5.675.675,0,0,1,.547.687C1292.5,713.576,1292.336,714.247,1291.9,714.407Z",
    transform: "translate(-1282.907 -711.754)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7085",
    "data-name": "Path 7085",
    d: "M1304.4,897.311l.905,19.418s7.553.123,7.338-1.586-2.723-17.238-2.723-17.238",
    transform: "translate(-1300.171 -887.738)",
    fill: "#e9f3fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7086",
    "data-name": "Path 7086",
    d: "M1231.812,896.2a73.286,73.286,0,0,1-1.12,8.443s-4.408.234-5.454-1.468c0,0,.828-7.006.828-8.427,0-.5-.038-1.179-.1-1.938-.091-1.15-.234-2.482-.369-3.642-.187-1.616-.36-2.9-.36-2.9l3.634-2.953Z",
    transform: "translate(-1225.098 -874.464)",
    fill: "#22407a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7087",
    "data-name": "Path 7087",
    d: "M1400.6,903.054a3.39,3.39,0,0,1-2.117.342,2.218,2.218,0,0,1-1.583,1.444c0-.013-.25-2.183-.544-4.741q-.044-.384-.089-.776c0-.022-.006-.045-.008-.067-.049-.428-.1-.862-.149-1.293-.355-3.08-.7-6.034-.7-6.034-.773-4.731-1.427-7.858-1.427-7.858,1.649.172,2.762.759,3.206,1.528,1.316,2.281,2.269,7.987,2.828,12.258,0,.011,0,.021,0,.033.1.737.18,1.431.253,2.057,0,.039.009.078.013.116C1400.5,901.852,1400.6,903.054,1400.6,903.054Z",
    transform: "translate(-1385.141 -875.181)",
    fill: "#22407a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7088",
    "data-name": "Path 7088",
    d: "M1384.955,884.077",
    transform: "translate(-1376.575 -875.186)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7089",
    "data-name": "Path 7089",
    d: "M1373.964,822.268s.072.222.632.141c0,0,.47-.068.435-.315A1.524,1.524,0,0,0,1373.964,822.268Z",
    transform: "translate(-1366.151 -816.371)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5889",
    "data-name": "Group 5889",
    transform: "translate(4.01 8.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7090",
    "data-name": "Path 7090",
    d: "M1300.244,874.752c-.009-.185.868-.441.868-.441a3.647,3.647,0,0,0,2.66,1.417,2.932,2.932,0,0,1-1.028,1.156S1300.3,875.853,1300.244,874.752Z",
    transform: "translate(-1300.244 -874.09)",
    fill: "#d9e9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7091",
    "data-name": "Path 7091",
    d: "M1368.635,881.079s.877-.52.88-1.083c0,0,.566-.071.814.2a2.917,2.917,0,0,1-.068,1.527S1369,881.534,1368.635,881.079Z",
    transform: "translate(-1365.107 -879.473)",
    fill: "#d9e9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7092",
    "data-name": "Path 7092",
    d: "M1356.181,894.287l1.189-.285a.18.18,0,0,1,.151.207,1.514,1.514,0,0,1-.481.8C1356.894,895.059,1355.9,894.679,1356.181,894.287Z",
    transform: "translate(-1353.248 -892.765)",
    fill: "#ba4c43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7093",
    "data-name": "Path 7093",
    d: "M1302.928,870.587c-.009-.185.585-.567.585-.567a4.186,4.186,0,0,0,2.805,1.368,2.933,2.933,0,0,1-1.028,1.156S1302.983,871.688,1302.928,870.587Z",
    transform: "translate(-1302.79 -870.02)",
    fill: "#e9f3fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7094",
    "data-name": "Path 7094",
    d: "M1368.635,877.533s.887-.47.89-1.034a2.835,2.835,0,0,1,.783.51,1.628,1.628,0,0,1-.047,1.171S1369,877.988,1368.635,877.533Z",
    transform: "translate(-1365.107 -876.165)",
    fill: "#e9f3fe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5888",
    "data-name": "Group 5888",
    transform: "translate(3.25 1.894)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7095",
    "data-name": "Path 7095",
    d: "M1365.681,922.5a2.521,2.521,0,0,1-.6,1.46l-.533.6a.272.272,0,0,1-.451-.039l-.643-1.009a1.549,1.549,0,0,1-.221-.96c.068-.77.2-2.253.3-3.684.085-1.16.156-2.286.167-2.971.035-2.187-.251-9.155-.251-9.155l.427.022a32.173,32.173,0,0,1,1.557,6.37c.128.9.225,1.869.268,2.867C1365.7,916,1365.888,919.979,1365.681,922.5Z",
    transform: "translate(-1363.229 -906.74)",
    fill: "#c65447"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7096",
    "data-name": "Path 7096",
    d: "M1365.681,1040a2.521,2.521,0,0,1-.6,1.46l-.533.6a.272.272,0,0,1-.451-.039l-.643-1.008a1.549,1.549,0,0,1-.221-.96c.068-.77.2-2.252.3-3.684a12.258,12.258,0,0,0,1.9-5.734c.128.9.225,1.869.268,2.867C1365.7,1033.5,1365.888,1037.484,1365.681,1040Z",
    transform: "translate(-1363.229 -1024.245)",
    fill: "#ba4c43"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_7097",
    "data-name": "Path 7097",
    d: "M1289.233,870.02s2.354,9.86,1.979,13.574a25.306,25.306,0,0,0-2.948-7.22s.76-.668.719-.915a2.6,2.6,0,0,0-1.112-.055s.061-4.25.4-4.7A2.487,2.487,0,0,1,1289.233,870.02Z",
    transform: "translate(-1284.5 -861.855)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7098",
    "data-name": "Path 7098",
    d: "M1385.3,876.5c-.353.029,2.333,9.635,2.532,12.714,0,0-.236-5.495-.213-7.078,0,0-.978-.518-.978-.7s1.043-.673,1.043-.673a20.091,20.091,0,0,0-1.021-3.756A3.014,3.014,0,0,0,1385.3,876.5Z",
    transform: "translate(-1376.868 -867.999)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7099",
    "data-name": "Path 7099",
    d: "M1479.446,1266.215a1.048,1.048,0,0,0-.059.775c.1.554.047.86.19.764a3.326,3.326,0,0,0,.44-.761Z",
    transform: "translate(-1466.101 -1237.609)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7100",
    "data-name": "Path 7100",
    d: "M1238.137,971.686c-2.741-.409-4.573-2.97-5.558-4.91-.092-1.15-.234-2.482-.369-3.642l.641-1.829Z",
    transform: "translate(-1231.71 -948.43)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7101",
    "data-name": "Path 7101",
    d: "M1442.057,1166.942a9.248,9.248,0,0,1-3.935.037q-.044-.384-.089-.776c0-.022-.005-.045-.008-.067.057-.222.114-.445.171-.667.981.351,3.173,1.12,3.847,1.357C1442.048,1166.866,1442.052,1166.9,1442.057,1166.942Z",
    transform: "translate(-1426.907 -1142.061)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7102",
    "data-name": "Path 7102",
    d: "M1226.3,883.3a5.733,5.733,0,0,0-3.508,1.839c-1.1,1.534,1.262,9.891,6.161,12.567,2.357,1.287,9.157,1.577,9.157,1.577s.374.037.522-.715a3.008,3.008,0,0,0,0-.71s-7.74-2.9-8.421-3.461S1226.3,883.3,1226.3,883.3Z",
    transform: "translate(-1222.527 -874.45)",
    fill: "#22407a"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner);
export default __webpack_public_path__ + "static/media/partner.ec25448b.svg";
export { ForwardRef as ReactComponent };